// extracted by mini-css-extract-plugin
module.exports = {"Subreddit":"subreddit_Subreddit__1OEOe","post":"subreddit_post__ZPayW","skeleton":"subreddit_skeleton__jI-_h"};